<template>
  <a-layout-header v-if="userInfo" class="dol-header">
    <div class="header-left">
      <div class="logo">箱通网管理平台</div>
      <a-menu
        class="mainMenu"
        mode="horizontal"
        :selectedKeys="selectMenu"
        @click="linkPage"
      >
        <template v-for="item in menuTree">
          <a-menu-item :key="item.ASSEMBLY">{{item.MENU_NAME}}</a-menu-item>
        </template>
      </a-menu>
    </div>
    <a-space>
      <the-menu-search />
      <a-dropdown class="account">
        <span class="accountInfo">
          <img src="../../../public/static/icon/icon.png" class="accountIcon" alt="Avatar">
          {{ userInfo.USER_NAME }}
          <a-icon type="down" />
        </span>
        <template #overlay>
          <a-menu @click="accountMenu">
            <a-menu-item key="changePwd">
              {{ $t('changePassword') }}
            </a-menu-item>
            <a-menu-item key="logout">
              {{ $t('logOut') }}
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </a-space>

    <a-modal :title="$t('changePassword')" v-model.trim="passwordDialog" :okText="$t('confirm')" :cancelText="$t('cancel')" :confirmLoading="changePwdLoading"
             @ok="changePwd">
      <dol-form-model :model="passwordForm" :rules="passwordValidateRules" ref="passwordForm">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('oldPassword')" prop="oldPassword">
              <a-input v-model.trim="passwordForm.oldPassword" type="password" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('newPassword')" prop="newPassword">
              <a-input v-model.trim="passwordForm.newPassword" type="password" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('confirmPassword')" prop="confirmPassword">
              <a-input v-model.trim="passwordForm.confirmPassword" type="password" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </dol-form-model>
<!--      <a-form class="editForm">
        <dol-form-item label="旧密码">
          <a-input v-model.trim="passwordForm.oldPassword" type="password" />
        </dol-form-item>
        <dol-form-item label="新密码">
          <a-input v-model.trim="passwordForm.newPassword" type="password" />
        </dol-form-item>
        <dol-form-item label="确认密码">
          <a-input v-model.trim="passwordForm.confirmPassword" type="password" />
        </dol-form-item>
      </a-form>-->
    </a-modal>
  </a-layout-header>
</template>

<script>
import TheMenuSearch from '@/components/common/the-menu-search';
import { mapState } from 'vuex';

export default {
  name: 'dol-header',
  components: { TheMenuSearch },
  data() {
    return {
      passwordDialog: false,
      passwordForm: {},
      changePwdLoading: false,
      passwordValidateRules: {
        oldPassword: [{required: true, message: this.$t('pleaseEnterTheOldPassword'), trigger: ['blur', 'change']}],
        newPassword: [{required: true, message: this.$t('pleaseEnterANewPassword'), trigger: ['blur', 'change']}],
        confirmPassword: [{required: true, message: '请确实新密码', trigger: ['blur', 'change']}],
      }
    };
  },
  computed: {
    ...mapState(['menuTree', 'userInfo']),
    selectMenu: {
      get() {
        return ['/' + this.$route.path.split('/')[1]];
      },
      set() {

      },
    }
  },
  methods: {
    accountMenu({ key }) {
      switch (key) {
        case 'changePwd':
          this.passwordForm = {};
          this.passwordDialog = true;
          break;
        case 'logout':
          this.$store.dispatch('logout').then(() => {
            this.$router.replace('/login');
          });
          break;
      }
    },
    changePwd(){
      this.$refs.passwordForm.validate(val =>{
        if(val){
          if(this.passwordForm.newPassword === this.passwordForm.confirmPassword){
            this.changePwdLoading = true;
            let commonParams = {
              USER_ID: this.userInfo.USER_ID,
              PASSWORD: this.passwordForm.oldPassword,
              NEW_PASSWORD: this.passwordForm.newPassword,
            }
            this.$h5Api({
              type: '2020',
              data: [commonParams],
              showMessage: false,
            }).then(({data, total}) => {
              this.$message.info(this.$t('modifySuccessfully'));
            })
          }else{
            this.$message.info(this.$t('theTwoPasswordEntriesAreInconsistent'));
          }
        }
      })
    },

    linkPage({ key }) {
      let pickMenu = this.menuTree.find(item => item.ASSEMBLY === key);

      let getFirstPage = (menu) => {
        if(menu.children.length > 0){
          return getFirstPage(menu.children[0])
        }else{
          return menu;
        }
      }

      let page = getFirstPage(pickMenu);

      this.$goPath(page);
    }
  },
  created() {
  }
};
</script>
